import React from 'react';
import CustomIcon from '../view/CustomIcon';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { TextField } from '../view/ViewElements';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import ProgressBar from '../view/ProgressBar';
import { handleComponentChange } from '../controllers/MainViewController';

function FormPage1(props) {

    const formComplete = (x) => {
      const { firstName, lastName, phone, emailAddress, featureFlags = {} } = x;
      
      const hasBasicFields = firstName && lastName && phone;
      const emailRequired = featureFlags.showEmailAddress === true;
      
      return hasBasicFields && (!emailRequired || emailAddress);
    };
      
    return (
        <>
            <Modal.Header className="mobile-consistent-header">
                <Col className="title-section">
                    <Modal.Title className='display-10'>Contact Details</Modal.Title>
                </Col>
                <Col className="progress-section">
                    <ProgressBar pageNumber={props.state.pageNumber} pages={props.state.pages} featureFlags={props.state.featureFlags} />
                </Col>
            </Modal.Header>
            <Modal.Body>
                <Row className="align-items-center mx-2 mx-sm-4 mx-md-5 mx-lg-auto" style={{ maxWidth: '600px' }}>
                    <Form onSubmit={props.nextPage} id={props.id}>
                        <TextField
                            style={{ border: !props.state.firstName ? '1px solid red' : undefined }}
                            label={<strong>First Name</strong>}
                            id="firstName"
                            value={props.state.firstName}
                            onChange={handleComponentChange(props.setState)} 
                            error={!props.state.firstName}
                        />
                        <TextField
                            label={<strong>Last Name</strong>}
                            id="lastName"
                            value={props.state.lastName}
                            onChange={handleComponentChange(props.setState)}
                            error={!props.state.lastName}
                        />
                        <TextField
                            label={<strong>Phone Number</strong>}
                            id="phone"
                            value={props.state.phone}
                            onChange={handleComponentChange(props.setState)}
                            error={!props.state.phone}
                        />
                        {props.state.featureFlags.showEmailAddress && (
                        <TextField
                            type="email"
                            label={<strong>Email Address</strong>}
                            id="emailAddress"
                            value={props.state.emailAddress}
                            onChange={handleComponentChange(props.setState)}
                            error={!props.state.emailAddress}
                        />
                        )}
                    </Form>
                </Row>
                {/* <Row className='align-items-right'> */}
                <Row className='row-buttons'>

                    <Col className='row-button-right'>
                        <Button
                            type="submit"
                            variant={formComplete(props.state) ? "outline-dark" : "secondary"}
                            disabled={!formComplete(props.state)}
                            form={props.id}
                        >
                            NEXT <CustomIcon icon={faAngleRight} />
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </>
    )
}

export default FormPage1;